export default[
	
	{
		code : "AG_REDIS_111",
		msg  	: 'A problem was found with the start of a service, please contact support',
		state 	: "111",
		type 	: 'error',
		module  : "redis",
	},
	{
		code : "AG_BK_RECORD_00-1",
		msg : 'Starting recording',
		state : "-1",
		type 	: 'primary',
		module  : "record",
		icon 	: "mdi-record-rec",
	},
	{
		code : "AG_BK_RECORD_002",
		msg : 'In this moment the cam is not recording',
		state : "2",
		type 	: 'secondary',
		module  : "record",
		icon 	: "mdi-stop-circle", // record-rec
		image 	: "/img/tags/record/grey.png",
	},

	{
		code : "AG_BK_RECORD_003",
		msg : 'The cam try restart record ',
		state : "3",
		type 	: 'warning',
		module  : "record",
		icon 	: "mdi-record-rec",		
	},
	{
		code : "AG_BK_RECORD_000",
		msg : 'The cam is recording',
		state : "0",
		type 	: 'success',
		module  : "record",
		icon 	: "mdi-record-rec",
	},
	{
		code : "AG_BK_DISK_000",
		msg 	: 'Disk in good condition.',
		state 	: "0",
		type 	: 'success',
		module  : "disk",
		icon 	: "mdi-harddisk",
	},
	{
		code : "AG_BK_DISK_001",
		msg : 'Disk not found, start with a disk default',
		state : "1",
		type 	: 'warning',
		module  : "disk",
		icon 	: "mdi-harddisk",
		
	},
	{
		code : "AG_BK_DISK_002",
		msg 	: 'Disk storage out of limit',
		state 	: "2",
		type 	: 'error',
		module  : "disk",
		icon 	: "mdi-harddisk",
	},
	{
		code : "AG_BK_DISK_007",
		msg  : 'Disk  created a default',
		state : "7",
		type 	: 'success',
		module  : "disk",
		icon 	: "mdi-harddisk",
	},
	{
		code : "AG_BK_DISK_011",
		msg : 'Disk error in create by default',
		state : "11",
		type 	: 'error',
		module  : "disk",
		icon 	: "mdi-harddisk",
	},
	{
		code : "AG_DEV_002",
		msg  :  'Error with device', 
		state : "2", 
		type 	: 'error',
		module  : "device",
		icon 	: "mdi-video",
	},
	{
		code : "AG_DEV_005",
		msg : 'Please check the device',
		state : "5",
		type 	: 'error',
		module  : "device",
		icon 	: "mdi-video",
	},
	{
		code : "AG_BK_GPS_017",
		msg : 'Not receiving coordinates, out of coverage',
		state : "17",
		type 	: 'error',
		module  : "gps",
		icon 	: "mdi-crosshairs-gps"

	},
	{
		code : "AG_BK_RECORD_004",
		msg : 'RTSP NULL, Required set a RTSP',
		state : "4",
		type 	: 'error',
		module  : "record",
		icon 	: "mdi-record-rec",
	},
	{
		code : "AG_BK_RETRASMISSION_000",
		msg 	: 'Retransmission in good connection',
		state 	: "0",
		type 	: 'success',
		module  : "retransmission",
		icon 	: "mdi-video-wireless",
	},
	{
		code : "AG_BK_RETRASMISSION_001",
		msg 	: 'Reconnecting relay',
		state 	: "1",
		type 	: 'warning',
		module  : "retransmission",
		icon 	: "mdi-video-wireless-outline",
	},
	{
		code : "AG_BK_RETRASMISSION_00-1",
		msg 	: "Starting video streaming", // RTSP its valid
		state 	: "-1",
		type 	: 'primary',
		module  : "retransmission",
		icon 	: "mdi-video-box",
	},
	{
		code : "AG_BK_RETRASMISSION_002",
		msg 	: 'Error with retransmission',
		state 	: "2",
		type 	: 'error',
		module  : "retransmission",
		icon 	: "mdi-video-off",
	},
	{
		code : "AG_BK_RETRASMISSION_003",
		msg 	: 'status retransmission : flashing',
		state 	: "3",
		type 	: 'warning',
		module  : "retransmission",
		icon 	: "mdi-video-off",
	},

	{
		code : "AG_BK_RETRASMISSION_004",
		msg 	: 'Closed retrasmission',
		state 	: "4",
		type 	: 'error',
		module  : "retransmission",
		icon 	: "mdi-video-off",
	},

	// RETRANSMISSION LOCAL


	{
		code : "AG_BK_RETRASMISSION_LOCAL_000",
		msg 	: 'Retransmission in good connection',
		state 	: "0",
		type 	: 'success',
		module  : "retransmission_local",
		icon 	: "mdi-server", // video-wireless
	},
	{
		code : "AG_BK_RETRASMISSION_LOCAL_001",
		msg 	: 'Reconnecting relay',
		state 	: "1",
		type 	: 'warning',
		module  : "retransmission_local",
		icon 	: "mdi-server", // video-wireless-outline
	},
	{
		code : "AG_BK_RETRASMISSION_LOCAL_00-1",
		msg 	: "Starting video streaming", // RTSP its valid
		state 	: "-1",
		type 	: 'primary',
		module  : "retransmission_local",
		icon 	: "mdi-server", // video-box
	},
	{
		code : "AG_BK_RETRASMISSION_LOCAL_002",
		msg 	: 'Error with retransmission',
		state 	: "2",
		type 	: 'error',
		module  : "retransmission_local",
		icon 	: "mdi-server-off", // video-off
	},
	{
		code : "AG_BK_RETRASMISSION_LOCAL_003",
		msg 	: 'status retransmission : flashing',
		state 	: "3",
		type 	: 'warning',
		module  : "retransmission_local",
		icon 	: "mdi-server-off",
	},
	{
		code : "AG_BK_RETRASMISSION_LOCAL_004",
		msg 	: 'Closed retrasmission',
		state 	: "4",
		type 	: 'error',
		module  : "retransmission_local",
		icon 	: "mdi-server-off",
	}, 


	// RETRANSMISION CLOUD

	{
		code : "AG_BK_RETRASMISSION_CLOUD_000",
		msg 	: 'Retransmission in good connection',
		state 	: "0",
		type 	: 'success',
		module  : "retransmission_cloud",
		icon 	: "mdi-cloud", // video-wireless
	},
	{
		code : "AG_BK_RETRASMISSION_CLOUD_001",
		msg 	: 'Reconnecting relay',
		state 	: "1",
		type 	: 'warning',
		module  : "retransmission_cloud",
		icon 	: "mdi-cloud", // video-wireless-outline
	},
	{
		code : "AG_BK_RETRASMISSION_CLOUD_00-1",
		msg 	: "Starting video streaming", // RTSP its valid
		state 	: "-1",
		type 	: 'primary',
		module  : "retransmission_cloud",
		icon 	: "mdi-cloud", //video-box
	},
	{
		code : "AG_BK_RETRASMISSION_CLOUD_002",
		msg 	: 'Error with retransmission',
		state 	: "2",
		type 	: 'error',
		module  : "retransmission_cloud",
		icon 	: "mdi-cloud-off", // video-off
	},
	{
		code : "AG_BK_RETRASMISSION_CLOUD_003",
		msg 	: 'status retransmission : flashing',
		state 	: "3",
		type 	: 'warning',
		module  : "retransmission_cloud",
		icon 	: "mdi-cloud-off",
	},
	{
		code : "AG_BK_RETRASMISSION_CLOUD_004",
		msg 	: 'Closed retrasmission',
		state 	: "4",
		type 	: 'error',
		module  : "retransmission_cloud",
		icon 	: "mdi-cloud-off",
	},

	{
		code : "AG_BK_PING_DEVICE_000",
		msg : 'Ping the device in good condition',
		state : "0",
		type 	: 'success',
		module  : "ping",
		icon 	: "mdi-lan-connect",
	},
	{
		code : "AG_BK_PING_DEVICE_001",
		msg : 'Device ping delaying',
		state : "1",
		type 	: 'warning',
		module  : "ping",
		icon 	: "mdi-lan-pending",
	},
	{
		code : "AG_BK_PING_DEVICE_002",
		msg :  'Ping with device not detected',
		state : "2",
		type 	: 'error',
		module  : "ping",
		icon 	: "mdi-lan-disconnect",
	},
	{
		code : "AG_BK_PING_NETWORK_000",
		msg 	: 'Ping the Network in good condition',
		state 	: "0",
		type 	: 'success',
		module  : "ping",
		icon 	: "mdi-network",
	},
	{
		code : "AG_BK_PING_NETWORK_002",
		msg 	: 'Ping with Network not detected',
		state 	: "2",
		type 	: 'error',
		module  : "ping",
		icon 	: "mdi-network-off",
	},
	{
		code : "AG_BK_RTSP_00-1",
		msg 	: "Loading transmission status", // RTSP its valid
		state 	: "-1",
		type 	: 'primary',
		module  : "rtsp",
		icon 	: "mdi-cctv", // video-box
	}, 
	{
		code : "AG_BK_RTSP_000",
		msg 	: "Video streaming it's working", // RTSP its valid
		state 	: "0",
		type 	: 'success',
		module  : "rtsp",
		icon 	: "mdi-cctv", // video-box
	},		
	{
		code : "AG_BK_RTSP_002",
		msg 	: 'Fail to get video streaming', // Issue with RTSP 
		state 	: "2",
		type 	: 'error',
		module  : "rtsp",
		icon 	: "mdi-cctv-off", // video-box
	},
	{
		code : "AG_BK_RTSP_102",
		msg 	: "No response from rtsp, check connection with video or transmitter",//'No response from the rtsp, ', // Issue with RTSP 
		state 	: "2",
		type 	: 'error',
		module  : "rtsp",
		icon 	: "mdi-cctv-off",	
	},
	{
		code : "AG_BK_RTSP_112",
		msg 	: 'Server saturated with requests', // Issue with RTSP 
		state 	: "2",
		type 	: 'error',
		module  : "rtsp",
		icon 	: "mdi-cctv-off",	
	},
	{
		code : "AG_BK_RTSP_122",
		msg 	: 'The RTSP is invalid, check it', // Issue with RTSP 
		state 	: "2",
		type 	: 'error',
		module  : "rtsp",
		icon 	: "mdi-cctv-off",
	},

	{
		code : "AG_BK_RTSP_132",
		msg 	: 'stream verification timed out', // Issue with RTSP 
		state 	: "2",
		type 	: 'error',
		module  : "rtsp",
		icon 	: "mdi-cctv-off",
	},
	{
		code : "AG_BK_RTSP_133",
		msg 	: 'Network is unreachable for Video Streaming', // Issue with RTSP 
		state 	: "2",
		type 	: 'error',
		module  : "rtsp",
		icon 	: "mdi-cctv-off",
	},

]